var React = require('react');

function AguilaPlusicon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"17","width":"40","height":"6","fill":"#A18347","key":0}),React.createElement("rect",{"x":"23","width":"40","height":"6","transform":"rotate(90 23 0)","fill":"#A18347","key":1})]);
}

AguilaPlusicon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = AguilaPlusicon;

AguilaPlusicon.default = AguilaPlusicon;
